import React, { useState } from 'react';
import { Plus, Search } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { DataTable } from '../../components/ui/DataTable';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { mockBranches } from '../../data/mockData';
import { useAuth } from '../../contexts/AuthContext';
interface BranchListProps {
  onAddBranch: () => void;
}
export function BranchList({
  onAddBranch
}: BranchListProps) {
  const {
    isMaker,
    isAdmin
  } = useAuth();
  const [searchTerm, setSearchTerm] = useState('');
  const [regionFilter, setRegionFilter] = useState('all');
  const filteredBranches = mockBranches.filter(b => {
    const matchesSearch = b.branchName.toLowerCase().includes(searchTerm.toLowerCase()) || b.branchCode.toLowerCase().includes(searchTerm.toLowerCase()) || b.city.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesRegion = regionFilter === 'all' || b.region.toLowerCase() === regionFilter.toLowerCase();
    return matchesSearch && matchesRegion;
  });
  return <div className="space-y-6" data-id="element-190">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-191">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-192">Branch Management</h2>
        {isAdmin && isMaker && <Button onClick={onAddBranch} leftIcon={<Plus className="w-4 h-4" data-id="element-194" />} data-id="element-193">
            Add New Branch
          </Button>}
      </div>

      <div className="flex flex-col sm:flex-row gap-4 bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-195">
        <div className="flex-1" data-id="element-196">
          <Input placeholder="Search by name, code, or city..." leftIcon={<Search className="w-4 h-4" data-id="element-198" />} value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-197" />
        </div>
        <div className="w-full sm:w-48" data-id="element-199">
          <Select options={[{
          value: 'all',
          label: 'All Regions'
        }, {
          value: 'Punjab',
          label: 'Punjab'
        }, {
          value: 'Sindh',
          label: 'Sindh'
        }, {
          value: 'KPK',
          label: 'KPK'
        }, {
          value: 'Balochistan',
          label: 'Balochistan'
        }, {
          value: 'Federal',
          label: 'Federal'
        }]} value={regionFilter} onChange={e => setRegionFilter(e.target.value)} data-id="element-200" />
        </div>
      </div>

      <DataTable columns={[{
      header: 'Code',
      accessor: 'branchCode',
      className: 'font-mono'
    }, {
      header: 'Branch Name',
      accessor: 'branchName'
    }, {
      header: 'City',
      accessor: 'city'
    }, {
      header: 'Region',
      accessor: 'region'
    }, {
      header: 'IBAN',
      accessor: b => <span className="font-mono text-xs" data-id="element-202">{b.iban}</span>
    }, {
      header: 'Status',
      accessor: b => <StatusBadge status={b.status} size="sm" data-id="element-203" />
    }, {
      header: 'Actions',
      accessor: () => <Button variant="ghost" size="sm" className="text-[#1B6B3A]" data-id="element-204">
                View
              </Button>
    }]} data={filteredBranches} data-id="element-201" />
    </div>;
}